import Loadable from '@townsquare/loadable';
import { appsRoute as appsRouteDefinition } from '@townsquare/routes/apps-view';

appsRouteDefinition.component = Loadable({
  loader: () => import(/* webpackChunkName: "apps-view" */ './components/AppsView'),
  loading: () => null,
});
export const appsRoute = appsRouteDefinition;
